/* import __COLOCATED_TEMPLATE__ from './errors.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();